import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal, Select, DatePicker } from 'components';
import { TrashIcon, ViewIcon, CleanIcon, AddWhiteIcon, TrashWhiteIcon, ConfirmIcon, StarIcon, GoogleMapsIcon, QuoteIcon, CloseWhiteIcon } from 'assets/icons';
import { Globals, checkPermission, Constants, Print, Colors } from 'utils';
import RequestQuote from '../request-quote';
import { Promo1, Promo2, NoPendingServiceImage, CalendarImage } from 'assets/img';
import moment from 'moment';
import { ClientQuoteService } from 'services';
import ModalView from './modal-view';
import ModalChangeDate from './modal-change-date';

interface LocationProps {
	quote_id: number | undefined;
	is_deep: number | undefined;
	open_confirm: boolean | undefined;
}

interface Props extends RootState, RouteComponentProps<{},{},LocationProps> {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	since: '',
	until: '',
	status: ''
}

declare var window: any;

class ClientQuotes extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		item: null,
		visible_view: false,
		visible_confirm: false,
		visible_confirm_cancel: false,
		visible_cancel: false,
		visible_date: false,
		is_deep: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Historial de Citas',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		if (this.props.location.state?.quote_id) {
			// // @ts-ignore
			this.loadQuote(this.props.location.state?.quote_id);
		}

		if (this.props.location.state?.open_confirm) {
			this.setState({
				visible_confirm: true,
				is_deep: !!this.props.location.state?.is_deep
			});
		}
		
		this.load();
	}

	loadQuote = async (quote_id: number) => {
		const res: any = await ClientQuoteService.client.getQuote({
			quote_id,
			withoutLoading: true
		});
		if (res.quote) {
			this.setState({
				item: res.quote,
				visible_view: true
			});
		}
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await ClientQuoteService.client.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
			user_id: this.props.user?.owner_id || this.props.user?.id
		});
		this.setState({
			data: res.quotes.rows,
			last_page: res.quotes.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	downloadExcel = async () => {
		const res: any = await ClientQuoteService.client.download({
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
			user_id: this.props.user?.owner_id || this.props.user?.id
		});
		if (window.webkit && window.webkit.messageHandlers) {
			const message = 'open_url';
			const sendToNative = {
				message,
				url: Constants.BASE_STORAGE + res.url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	    else {
	    	Print(Constants.BASE_STORAGE + res.url);
	    }
	}

	view = (item: any) => {
		this.setState({
			item,
			visible_view: true
		});
	}

	onCloseView = (reload: boolean = false, cancelled: boolean = false, edit: boolean = false) => {
		const item: any = this.state.item;

		this.setState({
			visible_view: false,
			item: null
		},() => {
			if (reload) {
				this.load(true);
			}
			if (cancelled) {
				this.setState({
					visible_cancel: true
				});
			}
			if (edit) {
				this.setState({
					item,
					visible_date: true
				});
			}
		});	
	}

	onCloseConfirm = () => {
		this.setState({
			visible_confirm: false
		});
	}

	confirmCancel = (e: any, item: any) => {
		e.preventDefault();
		e.stopPropagation();
		this.setState({
			visible_confirm_cancel: true,
			item
		});
	}

	cancel = async () => {
		await ClientQuoteService.client.cancelQuote({
			// @ts-ignore
			quote_id: this.state.item?.id
		});
		this.setState({
			visible_confirm_cancel: false,
			visible_cancel: true
		},() => this.load(true));
	}

	onCloseConfirmCancel = () => {
		this.setState({
			visible_confirm_cancel: false,
			item: null
		});
	}

	onCloseCancel = () => {
		this.setState({
			visible_cancel: false,
			item: null
		});
	}

	onCloseDate = () => {
		this.setState({
			visible_date: false,
			item: null
		},() => this.load(true));
	}

	getColor = (item: any) => {
		switch(item.status) {
			case Constants.QUOTE_STATUS.PENDING:
				return Colors.new_blue2;
			break;

			case Constants.QUOTE_STATUS.ASSIGNED:
				return Colors.new_blue3;
			break;

			case Constants.QUOTE_STATUS.IN_PROGRESS:
				return Colors.new_blue;
			break;

			case Constants.QUOTE_STATUS.FINISH:
				return Colors.new_green;
			break;

			case Constants.QUOTE_STATUS.CANCELLED:
				return Colors.new_gray;
			break;
		}

		return Colors.new_blue;
	}

	getTextColor = (item: any) => {
		switch(item.status) {
			case Constants.QUOTE_STATUS.PENDING:
				return Colors.new_green;
			break;

			case Constants.QUOTE_STATUS.ASSIGNED:
				return Colors.new_green;
			break;

			case Constants.QUOTE_STATUS.IN_PROGRESS:
				return Colors.new_green;
			break;

			case Constants.QUOTE_STATUS.FINISH:
				return Colors.new_blue;
			break;

			case Constants.QUOTE_STATUS.CANCELLED:
				return Colors.white;
			break;
		}

		return Colors.new_green;
	}

	getIconColor = (item: any) => {
		switch(item.status) {
			case Constants.QUOTE_STATUS.PENDING:
				return Colors.new_green;
			break;

			case Constants.QUOTE_STATUS.ASSIGNED:
				return Colors.new_green;
			break;

			case Constants.QUOTE_STATUS.IN_PROGRESS:
				return Colors.new_green;
			break;

			case Constants.QUOTE_STATUS.FINISH:
				return Colors.new_blue;
			break;

			case Constants.QUOTE_STATUS.CANCELLED:
				return Colors.gray;
			break;
		}

		return Colors.new_green;
	}
	
	render() {
		const { visible_view, visible_confirm, visible_cancel, visible_confirm_cancel, visible_date, is_deep } = this.state;

		return (
			<div id="client-quotes">
				<Modal
		          className="modal-quotes-view"
		          visible={ visible_view }
		          title="Orden de Servicio"
		          centered
		          onClose={ () => this.onCloseView() }
		        >
		        	<ModalView
		        		onClose={ (reload: boolean = false, cancelled: boolean = false, edit: boolean = false) => this.onCloseView(reload,cancelled,edit) }
		        		item={ this.state.item }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-confirm-quote"
		          visible={ visible_confirm }
		          title=""
		          centered
		          onClose={ () => this.onCloseConfirm() }
		        >
		        	<div id="modal-confirm-quote">
						<img src={ StarIcon } />
						<h3>{ !is_deep ? 'Su pago fue realizado' : 'Su solicitud fue realizada' }, espere confirmación de cita</h3>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-change-date"
		          visible={ visible_date }
		          title=""
		          centered
		          withoutClose={ true }
		          onClose={ () => this.onCloseDate() }
		        >
		        	<ModalChangeDate
		        		onClose={ () => this.onCloseDate() }
		        		item={ this.state.item }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-confirm-delete"
		          visible={ visible_confirm_cancel }
		          title=""
		          centered
		          onClose={ () => this.onCloseConfirmCancel() }
		        >
					<div id="modal-moderators-confirm-delete">
						<img src={ ConfirmIcon } />
						<h3>¿Está seguro de cancelar la cita?</h3>
						<div className="row">
							<div className="col-6 text-center">
								<button className="btn" onClick={ () => this.cancel() }>
									Aceptar
								</button>
							</div>
							<div className="col-6 text-center">
								<button className="btn btn-cancel" onClick={ () => {
									this.setState({
										visible_confirm_cancel: false,
										item: null
									});
								} }>
									Cerrar
								</button>
							</div>
						</div>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-message-delete"
		          visible={ visible_cancel }
		          title=""
		          centered
		          onClose={ () => this.onCloseCancel() }
		        >
					<div id="modal-moderators-message-delete">
						<img src={ StarIcon } />
						<h3>Se ha cancelado la cita</h3>
					</div>
		      	</Modal>

				<div className="row">
					<div className="col-md-12">
						<BackComponent />

						<div className="row row-filter">
							<div className="col-12">
								<div className="row">
									<div className="row col-md-10">
										<div className="col-md-3">
											<Input
												searchLeft
												value={ this.state.form.search }
												name="search"
												placeholder="Número de Orden"
												className="input-table"
												onSubmit={ () => this.load() }
												onChange={ (e: any) => {
													clearTimeout(this.timer);
													this.timer = setTimeout(() => {
														this.load(true);
													},1000);
													this.change(e); 
												} } />
										</div>
										<div className="col-md-3">
											<DatePicker
												placeholder="Desde"
												onChange={ (text: string) => {
													this.change({
														target: {
															value: text,
															name: 'since'
														}
													},() => this.load(true));
												} }
												value={ this.state.form.since }
											/>
										</div>
										<div className="col-md-3">
											<DatePicker
												placeholder="Hasta"
												onChange={ (text: string) => {
													this.change({
														target: {
															value: text,
															name: 'until'
														}
													},() => this.load(true));
												} }
												value={ this.state.form.until }
											/>
										</div>
										<div className="col-md-3">
											<Select
												placeholder="Estatus"
												name="status"
												onChange={ (e: any) => this.change(e,() => {
													this.load(true);
												}) }
												value={ this.state.form.status }
												options={ [
													{ value: Constants.QUOTE_STATUS.PENDING.toString(), label: 'Pendientes' },
													{ value: Constants.QUOTE_STATUS.IN_PROGRESS.toString(), label: 'En proceso' },
													{ value: Constants.QUOTE_STATUS.FINISH.toString(), label: 'Finalizadas' },
													{ value: Constants.QUOTE_STATUS.CANCELLED.toString(), label: 'Canceladas' }
												] } />
										</div>
									</div>
									<div className="col-md-2">
										{
											this.state.form != INITIAL_STATE && (
												<button className="btn btn-clean" onClick={ () => this.reset() }>
													<img src={ CleanIcon } />
												</button>
											)
										}
									</div>
								</div>
							</div>
						</div>

						{
							this.state.data.length > 0 && (
								<button className="btn btn-excel" onClick={ () => this.downloadExcel() }>
									Exportar a Excel
								</button>
							)
						}

						{
							this.state.data.map((item: any) => {
								return (
									<div className="item-quote" style={{
										backgroundColor: this.getColor(item)
									}} onClick={ () => this.view(item) }>
										<div className="container-text">
											<div className="container-icon" style={{
												backgroundColor: this.getIconColor(item)
											}}>
												<img src={ CalendarImage } />
											</div>
											<div className="container-number">
												<p className="number" style={{
													color: this.getTextColor(item)
												}}>Nº{ item.number }</p>
												<p className="status">{ item.status_text }</p>
											</div>
										</div>
										<div className="container-date">
											<div style={{ display: 'flex', alignItems: 'center' }}>
												{
													item.client_allowed_to_edit && item.status == Constants.QUOTE_STATUS.PENDING && (
														<button className="btn btn-cancel" onClick={ (e: any) => this.confirmCancel(e,item) }>
															<img src={ CloseWhiteIcon } />
															Cancelar cita
														</button>
													)
												}
											</div>
											<div>
												<p className="date">{ moment(item.date).format('DD/MM/YYYY') }</p>
												<p style={{
													color: this.getTextColor(item)
												}}>{ moment(item.journey?.since,'HH:mm').format('hh:mma') } - { moment(item.journey?.until,'HH:mm').format('hh:mma') }</p>
											</div>
											{
												item.client_allowed_to_edit && item.status == Constants.QUOTE_STATUS.PENDING && (
													<button className="btn btn-cancel btn-cancel-responsive" onClick={ (e: any) => this.confirmCancel(e,item) }>
														<img src={ CloseWhiteIcon } />
														Cancelar cita
													</button>
												)
											}
										</div>
									</div>
								)
							})
						}
						
						{
							this.state.data.length == 0 && (
								<div className="no-data text-center">
									<img src={ NoPendingServiceImage } />
									<p>Aun no se han solicitado servicios</p>
								</div>
							)
						}

						<Pagination 
							pages={ this.state.last_page } 
							active={ this.state.page }
							onChange={ async (page: number) => {
								await this.setState({
									page: page
								});
								this.load();
							} } />

					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ClientQuotes);